import React, { HTMLAttributes } from 'react';
import Icon from './Icon';
import styled from 'styled-components';
import { getColor } from '../styling/mixins/colors';
import { text } from '../styling/mixins/typography';

interface ChipAttributes {
  children?: any;
  showDelete?: boolean;
  onDeleteClick?: Function;
  chipProps?: HTMLAttributes<HTMLDivElement>;
}

const StyledChip = styled.div`
  ${text('small')}
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0.6rem 1.2rem;
  background-color: ${getColor('white')};
  border: 1px solid ${getColor('grey', 400)};
  gap: 0.8rem;

  .delete-icon {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

const Chip = (props: ChipAttributes) => {
  const { children, showDelete = true, chipProps = {}, onDeleteClick } = props;

  return (
    <StyledChip
      {...chipProps}
      className={`${chipProps.className ?? ''}`.trimEnd()}
    >
      {children}
      {showDelete && (
        <Icon
          name="close"
          cursor="pointer"
          className="delete-icon"
          onClick={() => onDeleteClick && onDeleteClick()}
        />
      )}
    </StyledChip>
  );
};

export default Chip;
